import AudioRecorder from 'audio-recorder-polyfill';
import mpegEncoder from 'audio-recorder-polyfill/mpeg-encoder';
AudioRecorder.encoder = mpegEncoder;
AudioRecorder.prototype.mimeType = 'audio/mpeg';
export default () => {
    const isMediaRecorderSupported = typeof window !== 'undefined' &&
        !window.MediaRecorder.notSupported &&
        //TODO check again when safari will support mediarecorder api
        !/^((?!chrome|android).)*safari/i.test(window.navigator.userAgent);
    if (!isMediaRecorderSupported) {
        Object.assign(window, {
            MediaRecorder: AudioRecorder,
        });
    }
};
